import { useEffect } from "react";
import anchorScrolling from "../../modules/anchor-scrolling";

const BasicPackage = ({ data, setLoadingPackages }) => {
  const { name, date, price } = data;
  const period = {
    30: "мес",
    90: "3мес",
    180: "6мес",
    365: "год",
  };

  useEffect(() => {
    anchorScrolling();
    setLoadingPackages(true);
  }, []);

  function changeOfDate(date) {
    return `${date.slice(8, 10)}.${date.slice(5, 7)}.${date.slice(0, 4)}`;
  }

  return (
    <>
      <li className="info-cards__price-item">
        <div className="info-cards__price-list-heading-wrap">
          <span className="info-cards__price-list-name">
            <a className="js-anchor-link" href="#main-tariff">
              {name}
            </a>
          </span>
          <span className="info-cards__price-list-description">
            {date.end.trim() === ""
              ? "Не действует"
              : `до ${changeOfDate(date.end)}`}
          </span>
        </div>
        <div className="info-cards__price-list-price-wrap">
          <span className="number number--dashboard">
            {Math.ceil(price.rubles)}{" "}
            <span className="number__units">Р/{period[price.days]}</span>
          </span>
        </div>
      </li>
    </>
  );
};

export default BasicPackage;
